import { PREVIEW_MODE } from '@/lib/previewMode';

/**
 * A fixed marker shown only in preview builds.
 *
 * The point is not decoration. A preview build renders every widget in its no-data state,
 * and several of those states — `0/-` cells, `N/A` badges, a `notAvailableText` row — look
 * exactly like a working display whose broker feed has died. Without a marker, a screenshot
 * from a preview URL is indistinguishable from a production incident, in either direction.
 *
 * Deliberately not dismissible and deliberately not subtle.
 */
export function PreviewBadge() {
  if (!PREVIEW_MODE) return null;

  return (
    <div
      // `pointer-events-none` so it can never intercept anything, though a signage display
      // has nothing to intercept. `z-[9999]` clears the slider, which sits at z-index 100.
      className="pointer-events-none fixed top-0 right-0 z-[9999] rounded-bl bg-amber-700 px-2 py-1 font-mono text-xs text-white opacity-90"
      aria-hidden="true"
    >
      PREVIEW · no live data
    </div>
  );
}
